import React from "react";

const Navbar = () => {
  return (
    <React.Fragment>
      <nav className="navbar navbar-dark bg-dark fixed-top">
        <a className="navbar-brand" href="#!">
          SocialGram
        </a>
      </nav>
    </React.Fragment>
  );
};

export default Navbar;
